import React from 'react';
import ReactDOM from 'react-dom';
import MainPage from './js/main/MainPage.jsx';

/* ─── 1. Tabla de entornos (solo para QA/Demo) ────────────────────────── */
const ENVS = {
  qa:         'https://testscannerupdate.rdmcorp.com/QA/Updates/',
  fs:         'https://testscannerupdate.rdmcorp.com/FS/Updates/',
  'PROD-2025':'https://testscannerupdate.rdmcorp.com/PROD-2025/',
  dev:        'https://testscannerupdate.rdmcorp.com/DEV/Updates/'
};

/* ─── 2. Decide la URL base del firmware ─────────────────────────────── */
const params      = new URLSearchParams(window.location.search);
const envId       = params.get('env');                // ?env=qa | fs | …
const DEFAULT_URL = 'https://testscannerupdate.rdmcorp.com/PROD-2025/';

const updateURL =
  (envId && ENVS[envId.toLowerCase()]) ||              // prioridad 1: query string
  window.__UPDATE_URL__ ||                             // prioridad 2: inyectado por index.ejs
  DEFAULT_URL;                                         // fallback

/* ─── 3. Opción de instalar certificado raíz ────────────────────────── */
const isRootCert = params.has('ROOTCERT');

/* ─── 4. Monta la aplicación ─────────────────────────────────────────── */
ReactDOM.render(
  <MainPage updateURL={updateURL} rootcert={isRootCert} />,
  document.getElementById('SelfServiceContainer')
);
